module.exports = "/* G:\\QSTCode\\ckeditor5-build\\src\\plugins\\ckeditor5-textintent\\src\\index.css */\n.ck-textindent{\r\n  text-indent: 2em\r\n}"